import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { Observable, Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

// Config
import { OptionInterface } from '../../../shared/interfaces';
import { IUser } from '../../../shared/interfaces/user.interface';
import { UserApiService } from '../../../shared/services/api/user-api.service';
import { trackByValue } from '../../../shared/util';

// Interfaces

// Services

@Component({
  selector: 'lum-filter-user',
  templateUrl: './filter-user.component.html',
  styleUrls: ['./filter-user.component.scss'],
})
export class FilterUserComponent implements OnInit, OnDestroy {
  @Input()
  placeholder :string = '';

  @Input()
  value :any = '';

  @Input()
  disabled :boolean = false;

  @Output()
  selectUser :EventEmitter<number> = new EventEmitter<number>();

  userControl = new UntypedFormControl('');
  users :OptionInterface[] = [];
  users$ :Observable<IUser[]>; // TODO: Create user interface

  trackByValue = trackByValue;

  private onDestroy$ = new Subject();

  constructor(
    private userApiService :UserApiService,
    private cd :ChangeDetectorRef,
  ) {}

  ngOnInit() :void {
    this.setDefaultValue();
    this.getDataFromService();
    this.getUsersFromObservable().subscribe();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onSelectUser(event :MatSelectChange) :void {
    this.selectUser.emit(event.value || event);
  }

  private getDataFromService() :void {
    this.users$ = this.userApiService.users;
  }

  private setDefaultValue() :void {
    // this.userControl.setValue(this.value)
  }

  private getUsersFromObservable() :Observable<IUser[]> {
    return this.users$.pipe(
      tap((users :IUser[]) => {
        if (users.length > 0) {
          this.users = users.map((row :any) => {
            return {
              value: String(row.id),
              label: `${row.firstname} ${row.lastname}`,
            };
          });
          this.cd.detectChanges();
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }
}
